import { ErrorHandler, EventEmitter, Injectable, Output } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { AlertType, IAlert } from '../models/alert.model';

@Injectable({ providedIn: 'root' })
export class AlertService implements ErrorHandler {
  @Output() alertEvent = new EventEmitter<IAlert>();

  private nextId = 0;
  private readonly ignoredErrorPatterns : RegExp[] =  [
    /^Failed to fetch$/i, // Ignoriere "Failed to fetch" Fehler, die von Angular beim Abbrechen von HTTP-Anfragen auftreten
    /Fetching Teams user/i,
  ]

  private isIgnoredError(error: Error): boolean {
    return this.ignoredErrorPatterns.some(pattern => { return pattern.test(error.message)});
  }

  /**
   * Basismethode, um einen Alert auszulösen.
   * id wird automatisch vergeben, damit mehrere gleichzeitige Alerts
   * eindeutig unterscheidbar (und einzeln schließbar) sind.
   */
  show(alert: Omit<IAlert, 'id'>): void {
    this.alertEvent.emit({ ...alert, id: ++this.nextId });
  }

  /** Für allgemeine Infomeldungen, die du manuell aus beliebigen Komponenten auslösen willst */
  info(message: string, useTimeout = true): void {
    this.show({
      type: AlertType.Info,
      popup: false,
      data: { message, useTimeout }
    });
  }

  /** Für manuell ausgelöste Fehlermeldungen (z. B. eigene Validierung) */
  error(message: string, code?: number): void {
    this.show({
      type: AlertType.Error,
      popup: false,
      data: { code, message, useTimeout: false }
    });
  }

  /** Wird automatisch von Angular aufgerufen, wenn dieser Service als globaler ErrorHandler registriert ist */
  handleError(error: unknown): void {
    if(error instanceof Error && this.isIgnoredError(error)) {
      console.debug('Ignored Error Message from CustomErrorHandler: ', error.message);
      return;
    }

    if (error instanceof HttpErrorResponse) {
      this.error(error.message, error.status);
    }
    else if (error instanceof Error) {
      this.error(error.message);
    }
    else {
      console.warn('Unknown Error from CustomErrorHandler: ', error);
    }
  }
}